import { useState } from 'react';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success('Successfully subscribed to our newsletter!');
      setEmail('');
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error('This email is already subscribed');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        data-testid="newsletter-email-input"
        className="flex-1 bg-[#060F22] border border-[#00AEEF]/30 text-white placeholder-[#94A3B8]/50 focus:border-[#FF6A00] focus:ring-1 focus:ring-[#FF6A00] rounded-xl px-4 py-3 transition-all"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-btn"
        className="inline-flex items-center justify-center bg-[#FF6A00] text-white font-bold rounded-xl px-6 py-3 shadow-[0_0_20px_rgba(255,106,0,0.3)] hover:shadow-[0_0_30px_rgba(255,106,0,0.5)] hover:-translate-y-1 transition-all duration-300 gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></span>
        ) : (
          <>
            Subscribe
            <Send className="w-4 h-4" />
          </>
        )}
      </button>
    </form>
  );
};

export default NewsletterForm;
